// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import App from './App'
import router from './router'
import Cover from 'vendors/cover/cover.js'
import 'vendors/cover/cover.css'
import moment from 'moment'
import store from './store'
import axios from 'axios'
import {auth} from '@/services/auth.service'
import '@/services/request.service'
import {EventBus} from '@/event-bus.js'
import Snotify from 'vue-snotify'
import 'vue-snotify/styles/material.css' // or dark.css or simple.css

import BatchMultiproc from './components/Clients/Btmic/BatchMultiproc'
import OtpLeasingBatchMultiproc from './components/Clients/OTPLeasing/BatchMultiproc'
import FileUpload from 'vue-upload-component'

Vue.config.productionTip = false
Vue.use(Cover)
Vue.use(VeeValidate)
Vue.use(Snotify)

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD HH:mm')
  }
})

/*
components registration
 */
Vue.component('btmic-batch-multiproc', BatchMultiproc)
Vue.component('otpleasing-batch-multiproc', OtpLeasingBatchMultiproc)
Vue.component('file-upload', FileUpload)

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  EventBus.$emit('hide-loading')

  // Do something with response data
  if (response.status === 401) { // not auth
    auth.login()
    return null
  }
  return response
}, function (error) {
  EventBus.$emit('hide-loading')
  // Do something with response error
  if (error.status === 401) { // not auth
    auth.login()
    return Promise.reject(error)
  }
  return Promise.reject(error)
})

axios.interceptors.request.use(config => {
  EventBus.$emit('show-loading')
  // return auth.getAccessToken().then(token => {
  //   config.headers.Authorization = `Bearer ${token}`
  //   return Promise.resolve(config)
  // })
  config.headers.Authorization = `Bearer ${auth.getAccessToken()}`
  return config
})

function onBeforeNavigateAuth (to, from, next) {
  let user = auth.user
  let isLoggedIn = (user !== null && !user.expired)
  if (!isLoggedIn) {
    auth.login()
  } else {
    store.dispatch('auth/getCurrentUserData').then(() => {
      if (store.getters['auth/shouldEnableMFA'] && to.name !== 'User2FA') {
        router.push({name: 'User2FA'})
      } else {
        next()
      }
    })
  }
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    onBeforeNavigateAuth(to, from, next)
  } else {
    next()
  }
})

/* eslint-disable no-new */
auth.startup().then(ok => {
  new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
  })
})



// WEBPACK FOOTER //
// ./src/main.js